import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13edfad5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "full"
}

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";
import ValidationMessage from '@/components/UI/ValidationMessage.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'JewelDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements('jewel', isCutout));
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid(isCutout));
const message = computed(() => store.getters.getInstructionsForDimension);

const widthTop = computed({
	get: () => dimensions.value.width_top,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width_top",
			value: value,
		});
	},
});

const widthBottom = computed({
	get: () => dimensions.value.width_bottom,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width_bottom",
			value: value,
		});
	},
});

const heightTop = computed({
	get: () => dimensions.value.height_top,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_top",
			value: value,
		});
	},
});

const heightBottom = computed({
	get: () => dimensions.value.height_bottom,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_bottom",
			value: value,
		});
	},
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "jewel-height_top",
        id: `${_ctx.prefix}measurements-jewel-height_top`,
        name: `${_ctx.prefix}measurements[dimensions][height_top]`,
        unit: "cm",
        label: dimensionLabel.value('height_top'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height_top'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}jewel-height_top`),
        onBlur: () => _unref(addSizeToDataLayer)('height_top', +heightTop.value, 'jewel'),
        modelValue: heightTop.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((heightTop).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "jewel-height_bottom",
        id: `${_ctx.prefix}measurements-jewel-height_bottom`,
        name: `${_ctx.prefix}measurements[dimensions][height_bottom]`,
        unit: "cm",
        label: dimensionLabel.value('height_bottom'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height_bottom'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}jewel-height_bottom`),
        onBlur: () => _unref(addSizeToDataLayer)('height_bottom', +heightBottom.value, 'jewel'),
        modelValue: heightBottom.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((heightBottom).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "jewel-width_top",
        id: `${_ctx.prefix}measurements-jewel-width_top`,
        name: `${_ctx.prefix}measurements[dimensions][width_top]`,
        unit: "cm",
        label: dimensionLabel.value('width_top'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width_top'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}jewel-width_top`),
        onBlur: () => _unref(addSizeToDataLayer)('width_top', +widthTop.value, 'jewel'),
        modelValue: widthTop.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((widthTop).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "jewel-width_bottom",
        id: `${_ctx.prefix}measurements-jewel-width_bottom`,
        name: `${_ctx.prefix}measurements[dimensions][width_bottom]`,
        unit: "cm",
        label: dimensionLabel.value('width_bottom'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width_bottom'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}jewel-width_bottom`),
        onBlur: () => _unref(addSizeToDataLayer)('width_bottom', +widthBottom.value, 'jewel'),
        modelValue: widthBottom.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((widthBottom).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      (message.value('width_top', 'width_bottom', _ctx.isCutout))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ValidationMessage, { type: "notice" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(message.value('width_top', 'width_bottom', _ctx.isCutout)), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})